import { Injectable } from '@angular/core';

import { RestOperatorsService } from "../../core/services/rest-operators.service";
import { UtilService } from "./util.service";
import { ProjetoService } from "../../projeto/shared/projeto.service";
import { RestService } from "../../core/services/rest.service";
import { DataService } from "../../core/services/data.service";

@Injectable()
export class AttService {
    private fileBase64: any;

    constructor(
        private _restOperatorsService: RestOperatorsService,
        private _restService: RestService,
        private _utilService: UtilService,
        private _projectService: ProjetoService,
        private _dataService: DataService
    ) {}

    isValidAttachment(files: any, onlyImage: boolean, onlyFile: boolean) {
        //files === e.target.files[0];
        if (files.length === 0) {
            return false;
        }

        let x: number, lenX: number, file: any, isValid: boolean;
        for (x = 0, lenX = files.files.length; x < lenX; x++) {
            file = files.files[x];

            if (onlyImage) {
                isValid = this.validImageFormat(file.type);
            } else if (onlyFile) {
                isValid = this.validFileFormat(file.type);
            } else {
                isValid = this.validAttachmentFormat(file.type);
            }

            if (!isValid) {
                break;
            }
        }

        if (isValid) {
            return true;
        } else {
            this._utilService.swalMessageWarningCustom("Arquivo com formato inválido!");
            return false;
        }
    }

    loadFile(file: any, responseSuccess: any)  {
        var oFReader = new FileReader();
        oFReader.onload = function (oFREvent: any) {
            if (this.validImageFormat(file.type)) {
                var img = new Image();
                img.onload = function () {
                    var canvas: any = this.cropImage(img);
                    this.fileBase64 = canvas.toDataURL();
                    this.uploadFile(file, responseSuccess);
                    //this.sendToS3(file, responseSuccess);
                }.bind(this);
                img.src = oFREvent.target.result;
            } else {
                this.fileBase64 = oFREvent.target.result;
                this.sendToS3(file, responseSuccess);
            }
        }.bind(this);

        oFReader.readAsDataURL(file);
    }

    private validImageFormat(attType: string) {
        let isValid: boolean = true;
        let TypeFileFromFormat: any[] = [
            'image/png', //png
            'image/jpg', //jpg
            'image/jpeg' //jpeg
        ];

        let format: any = TypeFileFromFormat.indexOf(attType);
        if (format === -1) {
            isValid = false;
        }

        return isValid;
    }

    private validFileFormat(attType: string) {
        let isValid: boolean = true;
        let TypeFileFromFormat: any[] = [
            'application/pdf' //pdf
            // 'application/msword', //doc
            // 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', //docx
            // 'application/vnd.ms-excel', //xls
            // 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', //xlsx
            // 'application/vnd.ms-powerpoint', //ppt
            // 'application/vnd.openxmlformats-officedocument.presentationml.presentation' //pptx
        ];

        let format: any = TypeFileFromFormat.indexOf(attType);
        if (format === -1) {
            isValid = false;
        }

        return isValid;
    }

    private validAttachmentFormat(attType: string) {
        let isValid: boolean = true;
        isValid = this.validImageFormat(attType);

        if (!isValid) {
            isValid = this.validFileFormat(attType);
        }

        return isValid;
    }

    //recorta a imagem
    private cropImage(img: any) {
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");

        let MAX_WIDTH = 600;
        let MAX_HEIGHT = 600;
        let width = img.width;
        let height = img.height;

        if (width > height) {
            if (width > MAX_WIDTH) {
                height *= MAX_WIDTH / width;
                width = MAX_WIDTH;
            }
        } else {
            if (height > MAX_HEIGHT) {
                width *= MAX_HEIGHT / height;
                height = MAX_HEIGHT;
            }
        }

        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, canvas.width, canvas.height);

        return canvas;
    }

    //obtem a extensao do arquivo
    private getAttachmentFormat(attachiment: any) {
        var attachimentType: any,
            object: any = {
                type: "",
                format: ""
            };

        attachimentType = attachiment.name.split(".");
        attachimentType = attachimentType[attachimentType.length - 1];
        if (attachimentType) {
            attachimentType = attachimentType.toLowerCase();
        }

        if (attachimentType === 'png') {
            object.type = 'image/png';
            object.format = attachimentType;
        } else if (attachimentType === 'jpg') {
            object.type = 'image/jpg';
            object.format = attachimentType;
        } else if (attachimentType === 'jpeg') {
            object.type = 'image/jpeg';
            object.format = attachimentType;
        } else if (attachimentType === 'pdf') {
            object.type = 'application/pdf';
            object.format = attachimentType;
        } else if (attachimentType === 'ppt') {
            object.type = 'application/vnd.ms-powerpoint';
            object.format = attachimentType;
        } else if (attachimentType === 'pptx') {
            object.type =  'application/vnd.openxmlformats-officedocument.presentationml.presentation';
            object.format = attachimentType;
        } else if (attachimentType === 'doc') {
            object.type = 'application/msword';
            object.format = attachimentType;
        } else if (attachimentType === 'docx') {
            object.type = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
            object.format = attachimentType;
        } else if (attachimentType === 'xls') {
            object.type = 'application/vnd.ms-excel';
            object.format = attachimentType;
        } else if (attachimentType === 'xlsx') {
            object.type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            object.format = attachimentType;
        }

        return object;
    }

    //coverte a imagem de base64 para blob
    private convertBase64ToBlob(base64: any, typeFile: any) {
        var ImageBase64 = atob(base64.split(',')[1]);
        var ArrayFileImage: any[] = [];
        var indiceArrayFileImage = 0;
        var arrayFileImagemLength = ImageBase64.length;
        for (; indiceArrayFileImage < arrayFileImagemLength; indiceArrayFileImage++) {
            ArrayFileImage.push(ImageBase64.charCodeAt(indiceArrayFileImage));
        }
        var ImageBlob = new Blob([new Uint8Array(ArrayFileImage)], {type: typeFile});
        return ImageBlob;
    }

    private sendToS3(file: any, callback: any){
        let fileExtension = this.getAttachmentFormat(file);
        let imageBase64 = this.fileBase64;
        let blobb = this.convertBase64ToBlob(imageBase64, file.type);
        this.getSignedRequest(file, blobb, fileExtension, callback);
    }

    //envia para o s3
    private getSignedRequest(file: any, blob: any, fileExtension: any, callback: any) {
        const route = 'anexo/sign';
        const apiRoute: string = this._restOperatorsService.getApiRoute(route, '');

        let xhr = new XMLHttpRequest();
        xhr.open("POST", apiRoute);
        xhr.setRequestHeader('Content-Type', 'application/json');

        let _utilService = this._utilService;
        xhr.onreadystatechange = function() {
            if(xhr.readyState === 4){
                var Response = JSON.parse(xhr.responseText);
                if(xhr.status === 200){
                    upload_file(blob, Response, callback);
                } else{
                    _utilService.swalMessageWarningCustom(Response.message);
                }
            } else {
                //"Could not get signed URL."
            }
        };

        let date = new Date();
        let timestamp = date.getTime();
        let project: any = this._projectService.getSessionStorage();
        let tenant: string = '';
        if (project && project.id) {
            tenant = project.nomeTenant;
        }

        let folder = tenant + "/" + timestamp + '.' + fileExtension.format;
        xhr.send(JSON.stringify({name: folder, type: file.type}));

        function upload_file(blob: any, Ass: any, callback: any){
            let signed_request = Ass.signature;

            let xhr = new XMLHttpRequest();
            xhr.open("PUT", signed_request);
            xhr.setRequestHeader('x-amz-acl', 'public-read');
            xhr.onload = function() {
                if (xhr.status === 200) {
                    Ass.location = folder;
                    Ass.fileExtension = fileExtension.format;
                    callback(Ass);
                }
            };
            xhr.onerror = function(x) {
                console.log(x);
                alert("Could not upload file.");
            };
            xhr.send(blob);
        }
    }

    //salva o upload no banco
    private uploadFile(file: any, callback: any) {
        var fileExtension = this.getAttachmentFormat(file);
        let date = new Date();
        let timestamp = date.getTime();
        let project: any = this._projectService.getSessionStorage();
        let tenant: string = '';
        if (project && project.id) {
            tenant = project.nomeTenant;
        }

        var folder = tenant + "/" + timestamp + '.' + fileExtension.format;
        var c: any = this.fileBase64.split(',');
        c = c[1];
        let object: any = {
            destino: folder,
            tipo: file.type,
            base64: c
        };

        const s3 = this._dataService.getS3();
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                Response.url = s3 + folder;
                Response.fileExtension = fileExtension.type;
                callback(Response);
            } else {
                this._utilService.swalMessageWarningCustom(Response.error);
            }
        }.bind(this));

        this._restService.onPostCustom('anexo/upload', object, onDone);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/services/att.service.ts
 **/